import { lazy } from "react";

export const PsychicsAsync = lazy(() => import("./Psychics"));
